import { IProvider } from '@/modules/gpt-chats/types/aimodel.service.type';

import OpenAI_Logo from '@/assets/logos/openai.svg';
import Azure_Logo from '@/assets/logos/azure-color.svg';
import Anthropic_Logo from '@/assets/logos/anthropic.svg';
import Google_Logo from '@/assets/logos/google.png';
import Mistral_Logo from '@/assets/logos/mistral-color.svg';
import DeepSeek_Logo from '@/assets/logos/deepseek-color.svg';
import OpenRouter_Logo from '@/assets/logos/open-router.svg';
import Custom_Logo from '@/assets/logos/Custom.png';

export const PROVIDER_LOGOS: Record<string, string> = {
  openai: OpenAI_Logo,
  azure: Azure_Logo,
  anthropic: Anthropic_Logo,
  google: Google_Logo,
  gemini: Google_Logo,
  mistral: Mistral_Logo,
  deepseek: DeepSeek_Logo,
  openrouter: OpenRouter_Logo,
  custom: Custom_Logo,
};

export enum ServicePlatform {
  OFFICIAL_API = 'official_api',
  OPEN_DEPLOYMENT = 'open_deployment',
  CUSTOM_DEPLOYMENT = 'custom_deployment',
}

export const createCustomProvider = () => {
  const customProvider: IProvider = {
    Provider: 'CUSTOM',
    Url: '',
    DocLink: '',
    Description:
      'Bring your own AI model to the platform by connecting external APIs for full customization and control.',
    Order: 999999,
  };
  return customProvider;
};

export enum ProviderType {
  OFFICIAL = 'official',
  OPEN = 'open',
  CUSTOM = 'custom',
}

export const ProviderToPlatformMap: Record<string, ServicePlatform> = {
  openai: ServicePlatform.OFFICIAL_API,
  anthropic: ServicePlatform.OFFICIAL_API,
  google: ServicePlatform.OFFICIAL_API,
  mistral: ServicePlatform.OFFICIAL_API,
  deepseek: ServicePlatform.OFFICIAL_API,

  azure: ServicePlatform.OPEN_DEPLOYMENT,
  openrouter: ServicePlatform.OPEN_DEPLOYMENT,

  custom: ServicePlatform.OPEN_DEPLOYMENT,
};

export const splitProvidersByPlatform = (providers: IProvider[] | null | undefined) => {
  const officialApi: IProvider[] = [];
  const openDeployment: IProvider[] = [];

  for (const p of providers ?? []) {
    if (!p || !p.Provider) {
      continue;
    }
    const platform = ProviderToPlatformMap[p.Provider.toLowerCase()];
    if (platform === ServicePlatform.OFFICIAL_API) officialApi.push(p);
    else openDeployment.push(p);
  }

  return { officialApi, openDeployment };
};

export const ProviderNameMap: Record<string, string> = {
  openai: 'OpenAI',
  anthropic: 'Anthropic',
  google: 'Gemini',
  mistral: 'Mistral',
  deepseek: 'DeepSeek',
  azure: 'Azure',
  openrouter: 'OpenRouter',
  custom: 'Custom Model',
};

export const getProviderDisplayName = (provider: string | undefined) => {
  if (!provider) return 'Provider';
  const mapped = ProviderNameMap[provider.toLowerCase()];
  if (mapped) return mapped;
  return provider.charAt(0).toUpperCase() + provider.slice(1);
};
